var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtdLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_179571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.31 4.225C9.78505 1.915 7.77005 0.875 6.00005 0.875C6.00005 0.875 6.00005 0.875 5.99505 0.875C4.23005 0.875 2.21005 1.91 1.68505 4.22C1.10005 6.8 2.68005 8.985 4.11005 10.36C4.64005 10.87 5.32005 11.125 6.00005 11.125C6.68005 11.125 7.36005 10.87 7.88505 10.36C9.31505 8.985 10.895 6.805 10.31 4.225ZM6.00005 6.73C5.13005 6.73 4.42505 6.025 4.42505 5.155C4.42505 4.285 5.13005 3.58 6.00005 3.58C6.87005 3.58 7.57505 4.285 7.57505 5.155C7.57505 6.025 6.87005 6.73 6.00005 6.73Z",
    fill: "#3C50AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_179571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtdLocationIcon);
export default __webpack_public_path__ + "static/media/ttd-location-icon.4411794dd5aaf384eb65c50f25f214bc.svg";
export { ForwardRef as ReactComponent };